export default __webpack_public_path__ + "static/developer-b48a2bdd969bf9d68a7acd0b051a00f1.png";